import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(main)/(profile)/page.module.scss");
import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(main)/(profile)/SidebarLinks.jsx");
import(/* webpackMode: "eager" */ "/app/src/app/components/footer/Footer.jsx");
import(/* webpackMode: "eager" */ "/app/src/app/components/navbar/Navbar.jsx")